// Arquivo gerado por scripts/generate-build-info.js. Nao edite manualmente.
export const BUILD_INFO = {
  "version": "10.0.0",
  "revision": "ca2c238",
  "builtAt": "2026-10-09T14:43:11.659Z",
  "buildId": "10.0.0-ca2c238-2026-10-09T14:43:11.659Z"
};
